import { render } from "./CurriculumTemplate.vue?vue&type=template&id=5eb8d4c1&scoped=true"
import script from "./CurriculumTemplate.vue?vue&type=script&lang=js"
export * from "./CurriculumTemplate.vue?vue&type=script&lang=js"

import "./CurriculumTemplate.vue?vue&type=style&index=0&id=5eb8d4c1&lang=scss&scoped=true"
import "./CurriculumTemplate.vue?vue&type=style&index=1&id=5eb8d4c1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb8d4c1"]])

export default __exports__